var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResponsesByQuestions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20.0 20.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rqi0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,0 L20,20 L0,20 L0,0 L20,0 Z M19,16 L1,16 L1,19 L19,19 L19,16 Z M19,12 L1,12 L1,15 L19,15 L19,12 Z M19,8 L1,8 L1,11 L19,11 L19,8 Z M19,4 L1,4 L1,7.001 L19,7.001 L19,4 Z M19,1 L1,1 L1,3 L19,3 L19,1 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rqi1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,0 L2,1 L0,1 L0,0 L2,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rqi2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,0 L3,1 L0,1 L0,0 L3,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rqi3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,0 L7,1 L0,1 L0,0 L7,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rqi0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 20,0 20,20 0,20 0,0",
    stroke: "none",
    fill: "#666666"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.0 5.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rqi1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 2,0 2,1 0,1 0,0",
    stroke: "none",
    fill: "#666666"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.0 9.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rqi1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 2,0 2,1 0,1 0,0",
    stroke: "none",
    fill: "#666666"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.0 13.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rqi1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 2,0 2,1 0,1 0,0",
    stroke: "none",
    fill: "#666666"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.0 17.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rqi1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 2,0 2,1 0,1 0,0",
    stroke: "none",
    fill: "#666666"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.0 5.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rqi2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 3,0 3,1 0,1 0,0",
    stroke: "none",
    fill: "#666666"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.0 9.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rqi2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 3,0 3,1 0,1 0,0",
    stroke: "none",
    fill: "#666666"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.0 13.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rqi2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 3,0 3,1 0,1 0,0",
    stroke: "none",
    fill: "#666666"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.0 17.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rqi2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 3,0 3,1 0,1 0,0",
    stroke: "none",
    fill: "#666666"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.0 5.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rqi3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7,0 7,1 0,1 0,0",
    stroke: "none",
    fill: "#666666"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.0 9.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rqi3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7,0 7,1 0,1 0,0",
    stroke: "none",
    fill: "#666666"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.0 13.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rqi3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7,0 7,1 0,1 0,0",
    stroke: "none",
    fill: "#666666"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.0 17.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rqi3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7,0 7,1 0,1 0,0",
    stroke: "none",
    fill: "#666666"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsesByQuestions);
export default __webpack_public_path__ + "static/media/ResponsesByQuestions.5dcc596c7e619e9b0998e078317c700d.svg";
export { ForwardRef as ReactComponent };